import { Category } from '@models/Category';
import { Response } from '@models/Response';
import * as api from './api';

export function get(): Promise<Response<Category>> {
  let url: string = 'categories?categoryIsActive=true';
  return api.get(url);
}

